// Notary fees estimator — France, indicative.
// Ancien: DMTO 5.80% + emoluments notaire (bareme progressif HT) + TVA 20% + CSI 0.10% + debours ~1000€.
// Neuf/VEFA: DMTO reduits ~0.715%, reste identique.

const TRANCHES = [
  [0, 6500, 0.03870],
  [6500, 17000, 0.01596],
  [17000, 60000, 0.01064],
  [60000, Infinity, 0.00799],
];

export function computeNotaryFees(price, kind = "ancien") {
  const p = Math.max(0, Number(price) || 0);
  const dmto = p * (kind === "neuf" ? 0.00715 : 0.0580);
  let emolumentsHT = 0;
  for (const [low, high, rate] of TRANCHES) {
    if (p > low) emolumentsHT += (Math.min(p, high) - low) * rate;
  }
  const emolumentsTTC = emolumentsHT * 1.20;
  const csi = p * 0.0010;
  const debours = 1000;
  const total = dmto + emolumentsTTC + csi + debours;
  return {
    dmto: Math.round(dmto),
    emolumentsHT: Math.round(emolumentsHT),
    emolumentsTTC: Math.round(emolumentsTTC),
    csi: Math.round(csi),
    debours,
    total: Math.round(total),
    pct: p > 0 ? total / p : 0,
  };
}
